import { useEffect, useLayoutEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';
export function useRouteScroll() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const positions = useRef(new Map<string, number>());
  const currentKey = useRef(location.key);
  const restoring = useRef(false);
  useEffect(() => {
    const previous = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    const save = () => {
      if (!restoring.current) positions.current.set(currentKey.current, window.scrollY);
    };
    window.addEventListener('scroll', save, { passive: true });
    return () => {
      window.removeEventListener('scroll', save);
      history.scrollRestoration = previous;
    };
  }, []);
  useLayoutEffect(() => {
    if (currentKey.current === location.key) return;
    currentKey.current = location.key;
    const top =
      navigationType === NavigationType.Pop ? (positions.current.get(location.key) ?? 0) : 0;
    restoring.current = true;
    let frame = 0;
    let timeout = 0;
    let observer: ResizeObserver | undefined;
    const stop = () => {
      restoring.current = false;
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
      observer?.disconnect();
      window.removeEventListener('wheel', stop);
      window.removeEventListener('pointerdown', stop);
      window.removeEventListener('keydown', stop);
    };
    const restore = () => {
      window.scrollTo({ top, behavior: 'instant' });
      if (Math.abs(window.scrollY - top) < 2) stop();
    };
    if (top > 0 && typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(restore);
      observer.observe(document.body);
    }
    frame = requestAnimationFrame(restore);
    timeout = window.setTimeout(stop, 1500);
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('pointerdown', stop, { passive: true });
    window.addEventListener('keydown', stop);
    if (!document.querySelector('[role="dialog"], [role="alertdialog"]'))
      document.getElementById('main-content')?.focus({ preventScroll: true });
    return stop;
  }, [location.key, navigationType]);
}
